import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAssignedOrders } from 'src/redux/deliveryboys'
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from '@coreui/react'

const AssignOrders = () => {
  const dispatch = useDispatch()
  const { assignedOrders } = useSelector((state) => state.deliveryboys)

  useEffect(() => {
    dispatch(getAssignedOrders())
  }, [dispatch])

  return (
    <div>
      <CTable striped hover responsive>
        <CTableHead color="dark">
          <CTableRow>
            <CTableHeaderCell>
              <small>Boy</small>
            </CTableHeaderCell>
            <CTableHeaderCell>
              <small>Customer</small>
            </CTableHeaderCell>
            <CTableHeaderCell>
              <small>Billing Address</small>
            </CTableHeaderCell>
            <CTableHeaderCell>
              <small>Shipping Address</small>
            </CTableHeaderCell>
            <CTableHeaderCell>
              <small>Amount</small>
            </CTableHeaderCell>
            <CTableHeaderCell>
              <small>Assigned At</small>
            </CTableHeaderCell>
            <CTableHeaderCell>
              <small>Location</small>
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {assignedOrders?.map((order) => (
            <CTableRow key={order.log_id}>
              <CTableDataCell>
                <small>{order.delivery_boy_name}</small>
              </CTableDataCell>
              <CTableDataCell>
                <small>{order.customer_name}</small>
              </CTableDataCell>
              <CTableDataCell>
                <small>{order.billing_address}</small>
              </CTableDataCell>
              <CTableDataCell>
                <small>{order.shipping_address}</small>
              </CTableDataCell>
              <CTableDataCell>
                <small>₹{order.total_amount}</small>
              </CTableDataCell>
              <CTableDataCell>
                <small>{new Date(order.assigned_at).toLocaleString()}</small>
              </CTableDataCell>
              <CTableDataCell>
                <small>{order.live_location ? JSON.stringify(order.live_location) : 'N/A'}</small>
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
    </div>
  )
}

export default AssignOrders
